export default function EmotionalShowcase() {
  return (
    <section
      className="py-24 md:py-40 bg-white"
      data-testid="showcase-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.22em] text-blue-600">
            Avant · Après
          </div>
          <h2
            className="font-display mt-5 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tighter text-slate-950 leading-[1.04]"
            data-testid="showcase-title"
          >
            Libérez vos espaces d'archives<br className="hidden sm:block" />
            <span className="text-blue-600"> sans mobiliser vos équipes.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-slate-500 leading-relaxed max-w-2xl mx-auto">
            Une solution simple, discrète et sécurisée pour vos archives confidentielles.
          </p>
        </div>

        <div className="mt-14 md:mt-20 max-w-5xl mx-auto rounded-[28px] overflow-hidden bg-slate-950">
          <img
            src="https://customer-assets.emergentagent.com/job_archives-secure-paca/artifacts/o7u6z8c5_ChatGPT%20Image%2025%20mai%202026%2C%2011_00_57.png"
            alt="Salle d'archives avant et après intervention ArchivExpress — étagères saturées de dossiers puis entièrement vidées"
            className="w-full h-auto object-contain block"
            loading="lazy"
            data-testid="showcase-image"
          />
        </div>
      </div>
    </section>
  );
}
